import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { PresentersRouteName } from '@/types/router/name/presenters';
import { PresentersRoutePath } from '@/types/router/path/presenters';

export default [
    {
        path: PresentersRoutePath.Presenters,
        name: PresentersRouteName.Presenters,
        component: () => import('@/pages/presenters/index.vue'),
        meta: {
            group: 'presenters',
            title: 'Profil Pemateri',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: PresentersRoutePath.Detail,
        name: PresentersRouteName.Detail,
        component: () => import('@/pages/presenters/detail/index.vue'),
        meta: {
            group: 'presenters-detail',
            title: 'Detail Presenter',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: PresentersRoutePath.Create,
        name: PresentersRouteName.Create,
        component: () => import('@/pages/presenters/create/index.vue'),
        meta: {
            group: 'presenters-create',
            title: 'Create Presenter',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: PresentersRoutePath.Edit,
        name: PresentersRouteName.Edit,
        component: () => import('@/pages/presenters/edit/index.vue'),
        meta: {
            group: 'presenters-edit',
            title: 'Edit Presenter',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
